import _ from 'lodash';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import types from 'frontend/state/actionTypes';

import { API_LOCALES } from 'shared/locale';

function localeReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.SELECT_LOCALE:
      return payload;
    default:
      return state;
  }
}

export default combineReducers({
  locale: localeReducer,
});

const rawLocaleSelector = state => state.locale.locale;
const localeSelector = createSelector(
  rawLocaleSelector,
  locale => _.find(API_LOCALES, { locale }) || _.find(API_LOCALES, { locale: 'en_US' }),
);

export const selectors = {
  rawLocale: rawLocaleSelector,
  locale: localeSelector,
};
